export const $USERS_FETCH_LIMIT: number = 10000;
export const companiesLimit: number = 10000;
export const compaignFileLimit: number = 1000;
export const $ABM_PAGINATION_LIMIT: number = 20;
